import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createPatientProfile.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createPatientProfile.error;
export const createPatientProfileResponse = (state: RootState) =>
  state.createPatientProfile.patientProfileResponse;
